import { createContext, PropsWithChildren, useEffect, useState } from "react";
import { useContext } from "react";
import Toast from "src/components/Toast";
import { v4 } from 'uuid'
export type ToastMessage = {
    message: string;
    type?: "error" | "success" | "warning";
}

type ToastContextType = {
    show: (message: string, type?: "error" | "success" | "warning", delay?: number) => void;
}
const ToastContext = createContext<ToastContextType>({
    show: () => null
});

ToastContext.displayName = "ToastContext";

type ToastProviderProps = {

}

export function ToastProvider({ children }: PropsWithChildren<ToastProviderProps>) {

    const [displayed, setDisplayed] = useState<(ToastMessage & { id: string })[]>([]);
    const [timeoutHandlers, setTimeoutHandlers] = useState<Record<string, NodeJS.Timeout>>({});

    useEffect(() => {
        return () => {
            for (const key in timeoutHandlers) {
                clearTimeout(timeoutHandlers[key]);
            }
            setDisplayed([]);
        }
    }, [])

    return (
        <ToastContext.Provider value={{
            show: (message, type = "success", delay = 3000) => {
                const id = v4();
                setDisplayed(prev => [{ message, type, id }, ...prev])

                const timeoutHandle = setTimeout(() => {
                    setDisplayed(prev => prev.filter(m => m.id !== id))
                    clearTimeout(timeoutHandlers[id]);
                }, delay)

                setTimeoutHandlers(prev => ({
                    ...prev, [id]: timeoutHandle
                }))
            }
        }}
        >
            {children}
            <div className='fixed top-12 w-full z-[999]'>
                {displayed.map((t, i) => <Toast key={i} message={t.message} type={t.type} onClose={() => setDisplayed(prev => prev.filter((p) => p.id !== t.id))} />)}
            </div>
        </ToastContext.Provider>
    )
};

export function useToast() {
    const value = useContext(ToastContext);

    if (process.env.NODE_ENV !== 'production') {
        if (!value) {
            throw new Error('useToast must be wrapped in a <ToastProvider />');
        }
    }
    return [value.show];
}


export default ToastProvider